import React from 'react';
import { Form as AntForm } from 'antd';

/**
 * Wrapper component for Ant Design Form
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Form functionality including sub-components and backward compatibility
 * with antd v3 API (Form.create() HOC pattern).
 * 
 * @component
 * @example
 * import { Form } from '../GeneralComponents/ui';
 * 
 * // Modern usage with hooks
 * const [form] = Form.useForm();
 * 
 * <Form form={form}>
 *   <Form.Item name="username" rules={[{ required: true }]}>
 *     <Input />
 *   </Form.Item>
 * </Form>
 * 
 * // Legacy usage with Form.create() (antd v3 compatibility)
 * const WrappedComponent = Form.create()(MyComponent);
 * 
 * @see https://ant.design/components/form/ - Ant Design Form documentation
 */
const Form = (props) => {
  return <AntForm {...props} />;
};

// Preserve Form.Item and other sub-components
Form.Item = AntForm.Item;
Form.List = AntForm.List;
Form.ErrorList = AntForm.ErrorList;
Form.useForm = AntForm.useForm;
Form.Provider = AntForm.Provider;
Form.createFormField = AntForm.createFormField;

export default Form;